import { forwardRef } from 'react';

import type { SVGIconProps } from '../types';

export const ArrowRightToLineIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.335 12.6664V3.33337C13.335 2.9661 13.6327 2.66833 14 2.66833C14.3673 2.66833 14.665 2.9661 14.665 3.33337V12.6664C14.665 13.0337 14.3673 13.3314 14 13.3314C13.6327 13.3314 13.335 13.0337 13.335 12.6664ZM6.86328 3.52966C7.12299 3.27013 7.54407 3.27002 7.80371 3.52966L11.8037 7.52966C11.9284 7.65437 11.998 7.824 11.998 8.00037C11.998 8.17654 11.9282 8.34547 11.8037 8.47009L7.80371 12.4701C7.54401 12.7298 7.12298 12.7298 6.86328 12.4701C6.60358 12.2104 6.60358 11.7894 6.86328 11.5297L9.72754 8.66541H2C1.63284 8.66541 1.33514 8.36749 1.33496 8.00037C1.33496 7.6331 1.63273 7.33533 2 7.33533H9.72852L6.86328 4.47009C6.60358 4.21039 6.60358 3.78936 6.86328 3.52966Z"
        fill={color}
      />
    </svg>
  ),
);

ArrowRightToLineIcon.displayName = 'ArrowRightToLineIcon';
